import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../providers/auth/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  /**
   * @description Constructor
   * @params authService
   * @params router
   */
  constructor(private authService: AuthService, private router: Router) {
    this.authService = authService;
    this.router = router;
  }
  /**
   * @description Can activate
   */
  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    let result = true;
    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['login']);
      result = false;
    }
    return result;
  }
}
